import {createSelector} from 'reselect';

import {ICC_PRODUCT_STATUS_TYPES} from '@/consts/icc/iccProductStatusTypes';
import {selectConsumerProducts} from '@/state/selectors/consumer';
import {selectChargerCodentify, selectHolderCodentify} from '@/state/selectors/mw';

const selectIsChargerRegistered = createSelector(
    selectConsumerProducts,
    selectChargerCodentify,
    (products, chargerCodentify) => {
        const product = products?.find((x) => x.codentify === chargerCodentify);

        return product?.status === ICC_PRODUCT_STATUS_TYPES.REGISTERED;
    }
);

const selectIsHolderRegistered = createSelector(
    selectConsumerProducts,
    selectHolderCodentify,
    (products, holderCodentify) => {
        const product = products?.find((x) => x.codentify === holderCodentify);

        return product?.status === ICC_PRODUCT_STATUS_TYPES.REGISTERED;
    }
);

export {selectIsChargerRegistered, selectIsHolderRegistered};
